import { render, staticRenderFns } from "./WAYH.vue?vue&type=template&id=04600d34&"
import script from "./WAYH.vue?vue&type=script&lang=js&"
export * from "./WAYH.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports